import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { connect } from "react-redux";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import * as actions from "../store/actions/actionIndex";
import LeadBucket from "../pages/callpanel/components/Preview/LeadBucket";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  paddingInlineEnd: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100vw - 20%)", 
  bgcolor: "white",
  boxShadow: 24,
  p: "2px",
  outline: "none",
};


const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

function CallModal(props) {
  const [updatedLeads, setUpdatedLeads] = useState(props.leads);

  useEffect(() => {
    setUpdatedLeads(props.leads);
  }, [props.leads]); 

  const handleSearch = () => {
    if (updatedLeads?.length > 0) {  // Safe check
      const phoneNumber = updatedLeads[0]?.phone1;
      if (phoneNumber) {
        props.onManualData(props.agentId, phoneNumber);
      } 
    } else {
      console.log("No leads available.");
    }
  };

  return (
    <Box sx={style}>
      <Box sx={{ bgcolor: "#f3f3f3", color: "black", p: "6px 10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography id="modal-modal-title" variant="h6">Lead Details</Typography>
        <IconButton onClick={props.onClose} sx={{ position: "absolute", top: "50%", insetInlineEnd: "8px", transform: "translateY(-50%)", color: "black" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <div className="leadbucket-data">
        <LeadBucket maxHeight="400px" leads={updatedLeads} searchAction={handleSearch} />
      </div>
    </Box>
  );
}


const mapStateToProps = (state) => {
  return {
    error: state.agentDial.error,
    loading: state.agentDial.loading,
    leadError: state.customerDetails.error,
    leadLoading: state.customerDetails.loading,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    custPhone: state.agentData.custPhone,
    campaignId: state.agentData.campaignId,
    leads: state.manualData.leads, 
    facilityConf: state.agentConfig.facilityConf,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onManualData: (agentId, phoneNo) => dispatch(actions.manualData(agentId, phoneNo)),
    onAgentDial: (agentId, phone, leadId) => dispatch(actions.agentDial(agentId, phone, leadId)),
    onGetCustomerDetails: (agentId, campaignId, leadId, leadType) =>
      dispatch(actions.getCustomerDetails(agentId, campaignId, leadId, leadType)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CallModal);
